import { http } from './http';
import type { ApiResponse, CurrentUser } from '@/types/contracts';

export interface LoginRequest {
  username: string;
  password: string;
}

export async function login(payload: LoginRequest): Promise<CurrentUser> {
  await http.post<ApiResponse<unknown>>('/api/v1/auth/login', payload);
  return getCurrentUser();
}

export async function getCurrentUser(): Promise<CurrentUser> {
  const response = await http.get<ApiResponse<CurrentUser>>('/api/v1/me');
  return response.data.data;
}

export async function logout(): Promise<void> {
  await http.post('/api/v1/auth/logout');
}

export async function getOauthAuthorizationUrl(): Promise<string> {
  const response = await http.get<ApiResponse<{ authorizationUrl: string }>>(
    '/api/v1/auth/oauth2/authorize-url',
  );
  return response.data.data.authorizationUrl;
}
